// extracted by mini-css-extract-plugin
module.exports = {"keyValueElementRoot":"OcXE8iIx","defaultVariant":"n8Y4xQry","title":"Vu_60r6N","details":"UhQ4q7s0","value":"sJ_eTQWK","unit":"K4aqT8di"};